import React from 'react'

export default function AgentFiles({visibleFile,setVisibleFile}) {
    return (
        <div className="icon-button-cont">

            <div className="tool-tip-cont">
                <div className="icon-button"
                    onClick={() => setVisibleFile(!visibleFile)}>
                    <div className="tool-tip">Ֆայլերի ցանկ</div>
                    <div className="add-file">
                        <i className="fas fa-file" />
                    </div>
                </div>
            </div>
        </div>
    )
}
